
const PAGE_UPGRADES_SELECTION = document.querySelector('#mhpUpgradesSelection');
const PAGE_UPGRADES_THANKYOU = document.querySelector('#mhpUpgradesThankYou');

//update price and default option
function upgrades_checkOption(optionId, el) {
  let upgradesSelectedOption = document.getElementById(`upgrades${el.dataset.id}_option_ID_${optionId}`);
  let newSelectedPrice = upgradesSelectedOption.dataset.pricedetails;
  if (el.checked) {
    upgradesSelectedOption.checked = true;
    document.getElementById(`displayPrice${el.dataset.id}`).innerText = newSelectedPrice;
  } else {
    if (!upgradesSelectedOption.checked) {
      let allOption = document.querySelectorAll(`.upgrades${el.dataset.id}`);
      allOption.forEach(option => {
        option.checked = false;
      });
    } else {
      upgradesSelectedOption.checked = false;
    }
    if (document.querySelectorAll(`.upgrades${el.dataset.id}`).length > 1) {
      document.getElementById(`displayPrice${el.dataset.id}`).innerText = "";
    }
  }
}

// Change price
function upgrades_changePrice(el) {
  let upgradeId = el.dataset.upgradesid;
  let newSelectedPrice = el.dataset.pricedetails;
  if (el.checked) {
    document.getElementById(`displayPrice${upgradeId}`).innerText = newSelectedPrice;
    document.getElementById(`upgrades_${upgradeId}`).checked = true;
  } else {
    document.getElementById(`displayPrice${upgradeId}`).innerText = "";
    document.getElementById(`upgrades_${upgradeId}`).checked = false;
  }
}

// Get state of Upgrades
function getUpgradesState(upgradesDataList) {
  for (const element of upgradesDataList) {
    if (element.selected) {
      return element.status;
    }
  }
  return "";
}

if (PAGE_UPGRADES_SELECTION) {
  let categorySetID = 0;

  const showThankYouPage = () => {
    document.querySelector('.upgrades-aditional-wrapper').classList.add("hidden");
    PAGE_UPGRADES_SELECTION.querySelector('.grid').classList.add("hidden");
    PAGE_UPGRADES_SELECTION.querySelector('.simple-callout-component').classList.add("hidden");
    PAGE_UPGRADES_SELECTION.querySelector('.mhp-upgrades-form').classList.add("hidden");
    if (document.getElementById("schemeUpgradesPopUp")) {
      PAGE_UPGRADES_SELECTION.querySelector('.schemeUpgradesPopUp').classList.add("hidden");
    }
    document.getElementById('upgrades-select-title').classList.add("hidden");
    document.getElementById('upgrades-unSelected-title').classList.add("hidden");
    document.getElementById("error-msg").classList.add("hidden");
    PAGE_UPGRADES_THANKYOU.classList.remove("hidden");
    document.getElementById('schemeUpdatesCheck').classList.add("hidden");
  };

  const showErrorMessageUpgrades = (message) => {
    document.getElementById("error-msg").classList.remove("hidden");
    document.getElementById("error-msg").innerHTML = `<p>${message}</p>`;
    document.querySelector('.upgrades-aditional-wrapper').classList.add("hidden");
    PAGE_UPGRADES_SELECTION.querySelector('.simple-callout-component').classList.add("hidden");
    PAGE_UPGRADES_SELECTION.querySelector('.grid').classList.add("hidden");
    PAGE_UPGRADES_SELECTION.querySelector('.mhp-upgrades-form').classList.add("hidden");
    if (document.getElementById("schemeUpgradesPopUp")) {
      PAGE_UPGRADES_SELECTION.querySelector('.schemeUpgradesPopUp').classList.add("hidden");
    }
    document.getElementById('upgrades-select-title').classList.add("hidden");
    document.getElementById('upgrades-unSelected-title').classList.add("hidden");
    document.getElementById('schemeUpdatesCheck').classList.add("hidden");
  };

  const getUpgrades = async function (params) {
    let previewMode = "";
    if (params.pageMode) {
      previewMode = previewMode + `&pageMode=${params.pageMode}`;
    }
    if (params.setid) {
      previewMode = previewMode + `&setid=${params.setid}`;
    }
    let response;
    response = await fetch(
      `${APIPrefix.get()}/api/mhp/upgrades?sitecode=${params.scode}&plotcode=${params.pcode}&language=${params.lang}${previewMode}`
    );
    if (response.status == 200) {
      let data = await response.json();
      if (data.status == "failure") {
        return data;
      } else if (data.status === "401") {
        APIUtils.redirectUserToSigninPage();
      } else {
        return data.data;
      }
    } else {
      let msg = document.querySelector('.rest-message--fail').value ? document.querySelector('.rest-message--fail').value : "";
      showErrorMessageUpgrades(msg);
      return false;
    }
  };

  const confirmUpgrades = async function (params, data) {
    let previewMode = "";
    if (params.pageMode) {
      previewMode = previewMode + `&pageMode=${params.pageMode}`;
    }
    let response;
    response = await fetch(
      `${APIPrefix.get()}/api/mhp/upgrades?sitecode=${params.scode}&plotcode=${params.pcode}&language=${params.lang}${previewMode}`,
      {
        method: 'POST',
        headers: {
          'Content-type': 'application/json',
        },
        body: JSON.stringify(data),
      }
    );
    if (response.status == 200) {
      let data = await response.json();
      if (data.status === "401") {
        APIUtils.redirectUserToSigninPage();
      } else {
        return data;
      }
    } else {
      let msg = document.querySelector('.rest-message--fail').value ? document.querySelector('.rest-message--fail').value : "";
      showErrorMessageUpgrades(msg);
      return false;
    }
  };


  const getParamsUpgradesFromUrl = (href = location.href) => {
    let url = new URL(href);
    let params = new URLSearchParams(url.search.slice(1));
    let previewParams = {};
    previewParams.pageMode = params.get('pageMode');
    previewParams.setid = params.get('setid');
    previewParams.lang = document.querySelector('[data-id="upgradesLang"]').value;
    previewParams.scode = document.querySelector('[data-id="upgradesSiteCode"]').value;
    previewParams.pcode = document.querySelector('[data-id="upgradesPlotCode"]').value;
    return previewParams;
  };

  //prepare object for submit
  const prepareSubmitObj = () => {
    let submitUpgradesArray = [];
    if (selectedUpgradesData.length > 0) {
      for (var i = 0; i < selectedUpgradesData.length; i++) {
        let upgradeId = selectedUpgradesData[i].dataset.upgradesid;
        let optionId = document.querySelector(`.upgrades${upgradeId}:checked`) ? document.querySelector(`.upgrades${upgradeId}:checked`).value : 0;
        submitUpgradesArray.push(
          { "categoryId": upgradeId, "optionId": optionId });
      }
    }
    let objSubmit = {
      categorySetID: categorySetID,
      UpgradeOptions: submitUpgradesArray,
    };
    return objSubmit;
  };

  //confirm submit
  const submitConfirmAction = () => {
    if (!document.getElementById("confirm_upgrades_btn").classList.contains("button--disabled")) {
      document.getElementById("confirm_upgrades_btn").classList.add("class", "button--disabled");
      let confirmedUpgrades = prepareSubmitObj();
      let parameters = getParamsUpgradesFromUrl();
      confirmUpgrades(parameters, confirmedUpgrades).then((success) => {
        if (success) {
          if (success.status == "failure") {
            jQuery('.bgmodalclose').trigger('click');
            showErrorMessageUpgrades(success.message);
          } else {
            jQuery('.bgmodalclose').trigger('click');
            document.getElementById("schemePopUpdates").classList.remove('open');
            showThankYouPage();
          }
        } else {
          console.log('failure confirm');
        }
      });
    }
  };

  document.addEventListener('DOMContentLoaded', () => {
    jQuery(document).ready(function () {
      jQuery('.mhp-upgrades-form').append("<div class='list-loader'></div>");
      let parameters = getParamsUpgradesFromUrl();
      if (parameters) {
        getUpgrades(parameters).then((response) => {
          if (response.status == "failure") {
            showErrorMessageUpgrades(response.message);
          } else {
            categorySetID = response.id;
            if (response.status === 0) {
              document.getElementById('upgrades-select-title').classList.remove("hidden");
            } else {
              document.querySelector('.upgrades-aditional-wrapper').classList.remove("hidden");
              document.getElementById('upgrades-unSelected-title').classList.remove("hidden");
              document.getElementById('upgrades-description').classList.remove("hidden");
            }
            let UPGRADES_CONTAINER = ``;
            if (response.upgradesDataList && response.upgradesDataList.length > 0) {
               // Upgrades not confirmed and User is original buyer
              if (response.status === 1 && response.isPurchaser) {
                response.upgradesDataList.forEach(upgradeDetails => {
                  let elentGrid = `<div class="grid line">`;
                  let elemOptions = `<div class="col col-4"> `;
                  let defaultSelectedOptionId = null;
                  upgradeDetails.upgradeOptions.forEach(UpgradeOptions => {
                    if (UpgradeOptions.selected) {
                      defaultSelectedOptionId = UpgradeOptions.id;
                    }
                    if (upgradeDetails.upgradeOptions.length === 1 && !upgradeDetails.isMultiple) {
                      elemOptions += `<div class="custom-control custom-radio">
                                                      <span  data-priceDetails="${UpgradeOptions.priceDetails}" data-upgradesid="${upgradeDetails.id}" id="upgrades${upgradeDetails.id}_option_ID_${UpgradeOptions.id}" class="upgrades${upgradeDetails.id}">
                                                          ${UpgradeOptions.title}
                                                      </span>
                                                  </div>`;
                    } else {
                      elemOptions += `<div class="custom-control custom-radio">
                                                    <label class="form--radio">
                                                      <input type="radio" onchange="upgrades_changePrice(this)" data-priceDetails="${UpgradeOptions.priceDetails}" data-upgradesid="${upgradeDetails.id}" id="upgrades${upgradeDetails.id}_option_ID_${UpgradeOptions.id}" class="upgrades${upgradeDetails.id}" name="upgrades_option_${upgradeDetails.id}" value="${UpgradeOptions.id}">
                                                      <span class="checkmark"></span>
                                                      <span>${UpgradeOptions.title}</span>
                                                  </label>
                                                  </div>`;
                    }
                  });
                  let elemCheckbox = `<div class="col col-4">
                                                    <label class="form--checkbox">
                                                          <input type="checkbox" onclick="upgrades_checkOption(${defaultSelectedOptionId}, this)" data-upgradesid="${upgradeDetails.id}" data-id="${upgradeDetails.id}" id="upgrades_${upgradeDetails.id}" name="upgrades_${upgradeDetails.id}" value="${upgradeDetails.id}">
                                                          <span class="checkmark" title="${upgradeDetails.tooltip}" ></span>
                                                          <span class="displayTitle">${upgradeDetails.title}</span>
                                                      </label>
                                                  </div>`;
                  elemOptions = elemOptions + `</div>`;
                  let elemPriceDetails = `<div class="col col-4">
                                                      <span class="displayPrice" id="displayPrice${upgradeDetails.id}">
                                                      </span>
                                                    </div>`;
                  if (upgradeDetails.upgradeOptions.length === 1) {
                    elemPriceDetails = `<div class="col col-4">
                                                            <span class="displayPrice" id="displayPrice${upgradeDetails.id}">
                                                              ${upgradeDetails.upgradeOptions[0].priceDetails}
                                                            </span>
                                                        </div>`;
                  }
                  UPGRADES_CONTAINER = UPGRADES_CONTAINER + elentGrid + elemCheckbox + elemOptions + elemPriceDetails + `</div>`;
                });
              } else {

                // If Upgrades still selectable and User is not Purchaser
                if (response.status === 1 && !response.isPurchaser) {
                  document.getElementById('upgrades-description').classList.remove("hidden");
                }

                switch (getUpgradesState(response.upgradesDataList)) {
                  case "pending":
                    document.getElementById('upgrades-description').remove();
                    document.getElementById('selected-unconfirmed-upgrades').classList.remove("hidden");
                    break;
                  case "confirmed":
                    document.getElementById('upgrades-description').remove();
                    document.getElementById('selected-confirmed-upgrades').classList.remove("hidden");
                    break;
                }

                let classValue = "";
                response.upgradesDataList.forEach(upgradeDetails => {
                  if (!response.isPurchaser || upgradeDetails.status === "pending" || upgradeDetails.status === "confirmed") {
                    classValue = "label--disabled";
                  }
                  let elentGrid = `<div class="grid line">`;
                  let elemCheckbox = '';
                  if (upgradeDetails.status === "confirmed") {
                    elemCheckbox = `<div class="col col-4">
                                                    <label class="form--checkbox ${classValue}">
                                                          <input type="checkbox" checked="true" disabled="true">
                                                          <span class="checkmark" title="${upgradeDetails.tooltip}"></span>
                                                          <span class="displayTitle">${upgradeDetails.title}</span>
                                                      </label>
                                          </div>`;
                  } else if (upgradeDetails.status === "pending") {
                    elemCheckbox = `<div class="col col-4">
                                                    <label class="form--checkbox ${classValue}">
                                                          <span class="checkmark checkmark-pending" title="${upgradeDetails.tooltip}">${document.querySelector('[data-id="upgradesPendingMessage"]').value}</span>
                                                          <span class="displayTitle">${upgradeDetails.title}</span>
                                                      </label>
                                          </div>`;
                  } else {
                    elemCheckbox = `<div class="col col-4">
                                              <label class="form--checkbox ${classValue}">
                                                    <input type="checkbox" disabled="true">
                                                    <span class="checkmark" title="${upgradeDetails.tooltip}"></span>
                                                    <span class="displayTitle">${upgradeDetails.title}</span>
                                                </label>
                                            </div>`;
                  }
                  let elemOptions = `<div class="col col-4"> `;
                  let priceDetailsAccepted = "";
                  upgradeDetails.upgradeOptions.forEach(UpgradeOptions => {
                    if (upgradeDetails.upgradeOptions.length === 1 && !upgradeDetails.isMultiple) {
                      elemOptions += `<div class="custom-control custom-radio">
                                                    <span>${UpgradeOptions.title}</span>
                                                </div>`;
                    } else {
                      if ((upgradeDetails.status === "pending" || upgradeDetails.status === "confirmed") && UpgradeOptions.selected) {
                        priceDetailsAccepted = UpgradeOptions.priceDetails;
                        elemOptions += `<div class="custom-control custom-radio">
                                                                    <label class="form--radio ${classValue}">
                                                                      <input type="radio" checked="true"" data-priceDetails="${UpgradeOptions.priceDetails}" data-upgradesid="${upgradeDetails.id}" id="upgrades${upgradeDetails.id}_option_ID_${UpgradeOptions.id}" class="upgrades${upgradeDetails.id}" name="upgrades_option_${upgradeDetails.id}" value="${UpgradeOptions.id}" disabled="true">
                                                                      <span class="checkmark"></span>
                                                                      <span>${UpgradeOptions.title}</span>
                                                                  </label>
                                                                  </div>`;
                      } else {
                        elemOptions += `<div class="custom-control custom-radio">
                                                                  <label class="form--radio ${classValue}">
																	                                  <input type="radio" data-priceDetails="${UpgradeOptions.priceDetails}" data-upgradesid="${upgradeDetails.id}" id="upgrades${upgradeDetails.id}_option_ID_${UpgradeOptions.id}" class="upgrades${upgradeDetails.id}" name="upgrades_option_${upgradeDetails.id}" value="${UpgradeOptions.id}" disabled="true">
                                                                    <span class="checkmark"></span>
                                                                    <span>${UpgradeOptions.title}</span>
                                                                </label>
                                                                </div>`;
                      }
                    }
                  });
                  elemOptions = elemOptions + `</div>`;
                  let elemPriceDetails = `<div class="col col-4">
                                                <span class="displayPrice">
                                                </span>
                                              </div>`;
                  if (upgradeDetails.status === "pending" || upgradeDetails.status === "confirmed") {
                    if (upgradeDetails.upgradeOptions.length === 1) {
                      elemPriceDetails = `<div class="col col-4">
                                                            <span class="displayPrice">
                                                              ${upgradeDetails.upgradeOptions[0].priceDetails}
                                                            </span>
                                                        </div>`;
                    } else {
                      elemPriceDetails = `<div class="col col-4">
                                                    <span class="displayPrice">
                                                    ${priceDetailsAccepted}
                                                    </span>
                                                  </div>`;
                    }
                  }
                  UPGRADES_CONTAINER = UPGRADES_CONTAINER + elentGrid + elemCheckbox + elemOptions + elemPriceDetails + `</div>`;
                });
              }
              document.querySelector('.mhp-upgrades-form').innerHTML = UPGRADES_CONTAINER;
              if (response.status === 1 && response.isPurchaser) {
                document.querySelector('.schemeUpgradesPopUp').classList.remove("hidden");
              }
            } else {
              document.querySelector('.mhp-upgrades-form').innerHTML = UPGRADES_CONTAINER;
            }
          }
        });
      } else {
        document.querySelector('.mhp-upgrades-form').innerHTML = '';
      }
    });
  });

  let selectedUpgradesData = [];

  //Display error message if no CheckBox is checked.
  if (document.getElementById("schemeUpdatesCheck")) {
    document.getElementById("schemeUpdatesCheck").addEventListener('click', function (event) {
      selectedUpgradesData = $(".mhp-upgrades-form input[type=checkbox]:checked");
      prepareSubmitObj();
      let isChecked = selectedUpgradesData.length;
      if (isChecked > 0) {
        document.querySelectorAll(".upgrades-error").forEach(el => {
          el.classList.add("hidden");
        });
        document.querySelectorAll(".upgrades-success").forEach(el => {
          el.classList.remove("hidden");
          document.getElementById("confirm_upgrades_btn").classList.remove("hidden");
        });
      } else {
        document.querySelectorAll(".upgrades-success").forEach(el => {
          el.classList.add("hidden");
          document.getElementById("confirm_upgrades_btn").classList.add("hidden");
        });
        document.querySelectorAll(".upgrades-error").forEach(el => {
          el.classList.remove("hidden");
        });
      }
    });
  }

  document.getElementById("confirm_upgrades_btn").addEventListener('keypress', function (event) {
    if (event.key === 'Enter') {
      submitConfirmAction();
    }
  });

  document.getElementById("confirm_upgrades_btn").addEventListener('click', function (event) {
    submitConfirmAction();
  });

}
